/**
 * Inspiration / reference image limits for the ad-creator graphics editor (VP-146).
 * Dependency-free so the boundary logic can be unit-tested without React.
 */

// Max number of inspiration images a user can attach. Kept ≤ the backend
// `referenceImages` cap (.max(10)); the UI stops at this number with a clear
// message instead of letting an oversized/over-count request fail.
export const MAX_INSPIRATION_FILES = 8;

/** How many more inspirations can be added given the current count (never negative). */
export function availableInspirationSlots(
  currentCount: number,
  max: number = MAX_INSPIRATION_FILES
): number {
  return Math.max(0, max - currentCount);
}
